module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_suspended.1aeee9d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_suspended.svg
// module id = 3197
// module chunks = 0